/**
 * Mock auth — dev auth bootstrap for the mock data plane.
 *
 * The auth store is persisted (see useAuthStore `persist` middleware), so a
 * signed-in role survives a refresh. A first-time visitor has no persisted
 * user and simply starts as `public` (Drones + OI only); every other context
 * prompts a login. We therefore do NOT reset the user here — rehydration owns
 * the initial state.
 *
 * Real auth uses oidc-client-ts wired in lib/auth/keycloak.ts (TODO — 86e232ykg).
 */
import { useAuthStore } from '@/lib/store/auth';

export function bootstrapMockAuth() {
  // No-op: persisted rehydration restores the session. Returned for callers
  // that want the current identity without importing the store.
  return useAuthStore.getState().user;
}
